/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ControlEntityAssetTechResult } from './ControlEntityAssetTechResult';
import {
    ControlEntityAssetTechResultFromJSON,
    ControlEntityAssetTechResultFromJSONTyped,
    ControlEntityAssetTechResultToJSON,
} from './ControlEntityAssetTechResult';

/**
 * 
 * @export
 * @interface ControlPaginatedEntityAssetTechResponse
 */
export interface ControlPaginatedEntityAssetTechResponse {
    /**
     * 
     * @type {number}
     * @memberof ControlPaginatedEntityAssetTechResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof ControlPaginatedEntityAssetTechResponse
     */
    page_size?: number;
    /**
     * 
     * @type {number}
     * @memberof ControlPaginatedEntityAssetTechResponse
     */
    count?: number;
    /**
     * 
     * @type {Array<ControlEntityAssetTechResult>}
     * @memberof ControlPaginatedEntityAssetTechResponse
     */
    results?: Array<ControlEntityAssetTechResult>;
}

/**
 * Check if a given object implements the ControlPaginatedEntityAssetTechResponse interface.
 */
export function instanceOfControlPaginatedEntityAssetTechResponse(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ControlPaginatedEntityAssetTechResponseFromJSON(json: any): ControlPaginatedEntityAssetTechResponse {
    return ControlPaginatedEntityAssetTechResponseFromJSONTyped(json, false);
}

export function ControlPaginatedEntityAssetTechResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlPaginatedEntityAssetTechResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'page': !exists(json, 'page') ? undefined : json['page'],
        'page_size': !exists(json, 'page_size') ? undefined : json['page_size'],
        'count': !exists(json, 'count') ? undefined : json['count'],
        'results': !exists(json, 'results') ? undefined : ((json['results'] as Array<any>).map(ControlEntityAssetTechResultFromJSON)),
    };
}

export function ControlPaginatedEntityAssetTechResponseToJSON(value?: ControlPaginatedEntityAssetTechResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'page': value.page,
        'page_size': value.page_size,
        'count': value.count,
        'results': value.results === undefined ? undefined : ((value.results as Array<any>).map(ControlEntityAssetTechResultToJSON)),
    };
}

